import reducer from "./reducer";
import * as actions from "./actions";
import * as selectors from "./selectors";

export { default as TeamNationalityGame } from "./components/TeamNationalityGame";

export default { reducer, actions, selectors };
